'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FaCalendarAlt, FaHammer, FaMapPin } from 'react-icons/fa';
import { HiDocumentArrowDown } from 'react-icons/hi2';

export const ReferenceCards = ({
  reference,
  referencePage,
}: {
  reference: any;
  referencePage: any;
}) => {
  async function downloadSheet(sheetUrl: string) {
    try {
      const response = await fetch(sheetUrl);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', sheetUrl.split('/').pop() || 'download.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading the sheet:', error);
    }
  }

  const handleDownloadClick = () => {
    if (reference?.sheet?.url) {
      downloadSheet(reference.sheet.url);
    }
  };

  const detailCards: Array<{
    icon: JSX.Element;
    title: string | number;
    description: string | number;
    onClick?: () => void;
  }> = [
    {
      icon: <FaHammer size={32} className="text-primary" />,
      title: referencePage?.data?.dynamic_data?.[4]?.value,
      description: reference?.name,
    },
    {
      icon: <FaCalendarAlt size={32} className="text-primary" />,
      title: referencePage?.data?.dynamic_data?.[5]?.value,
      description: reference?.year,
    },
    {
      icon: <FaMapPin size={32} className="text-primary" />,
      title: referencePage?.data?.dynamic_data?.[6]?.value,
      description: `${reference?.city}, ${reference?.country?.name}`,
    },
    {
      icon: <HiDocumentArrowDown size={32} className="text-primary" />,
      title: referencePage?.data?.dynamic_data?.[7]?.value,
      description: referencePage?.data?.dynamic_data?.[8]?.value,
      onClick: handleDownloadClick,
    },
  ];

  return (
    <div className={cn('', 'ea-reference-detail-page__info-wrapper')}>
      {detailCards.map((card, index) => (
        <div
          key={index}
          className={cn('', 'ea-reference-detail-page__info-card')}
          onClick={card.onClick}
        >
          {card.icon}
          <div>
            <p className={cn('', 'ea-reference-detail-page__info-title')}>{card.title}</p>
            <p className={cn('', 'ea-reference-detail-page__info-description')}>
              {card.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
